import { getConfig } from './config';

export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const { apiBase } = getConfig();
  const url = `${apiBase}${path.startsWith('/') ? path : `/${path}`}`;
  const merged: RequestInit = {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(init?.headers || {}) },
    ...init,
  };
  return fetch(url, merged);
}


